import script from "./ReviewActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewActions.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewActions.vue?vue&type=style&index=0&id=56343578&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56343578"]])

export default __exports__